<app-shared-dialog
  [title]="'custom_fields.custom_fields' | translate"
  [options]="{
    titleIcon: 'chevrons',
    titleIconColor: 'primary',
    confirmText: 'common.save' | translate,
    cancelText: 'common.cancel' | translate,
    confirmButtonStyle: 'primary',
    confirmIcon: 'arrow-right',
    confirmIconPosition: 'end',
    customConfirmButton: true
  }" (cancel)="cancel()">
  <div class="custom-fields-container">
    <app-object-custom-fields-form
      [objectCustomFields]="data.objectCustomFields"
      (save)="saveInventoryCustomFields($event)"
      [showSaveButton]="false"
    ></app-object-custom-fields-form>
  </div>
  <ui-button
    customConfirm
    *appHasPermission="{ module: 'product', action: 'edit' }"
    type="primary"
    [label]="'common.save' | translate"
    icon="arrow-right"
    iconPosition="end"
    (click)="save()">
  </ui-button>
</app-shared-dialog>